<template>
  <div>
    <div>
      <el-row :gutter="20">
        <el-col :span="20">
          时间筛选：<el-date-picker v-model="upload_at" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 30%;" @change="updateDateChange" size="mini"></el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="exports()">财务报表</el-button>
        </el-col>
      </el-row>
      <el-table :data="dataList" style="width: 100%" v-loading="loadingList">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="user_id" label="用户ID"></el-table-column>
        <el-table-column prop="realname" label="姓名"></el-table-column>
        <el-table-column prop="goods_info" label="标题"></el-table-column>
        <el-table-column prop="connact_mobile" label="手机号"></el-table-column>
        <el-table-column prop="origin_mobile" label="推荐人手机号"></el-table-column>
        <el-table-column prop="origin_name" label="推荐人"></el-table-column>
        <el-table-column prop="user_serial_number" label="赠送单号"></el-table-column>
        <el-table-column prop="user_serial_money" label="金額"></el-table-column>
        <el-table-column prop="origin_serial_number" label="推荐人赠送单号"></el-table-column>
        <el-table-column prop="origin_serial_money" label="金额"></el-table-column>
        <el-table-column  label="生成时间">
          <template slot-scope="scope">
            {{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>

      </el-table>

      <div class="content-padded content-center" v-if="pagers.total>0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="fetchParams.page"
          :page-sizes="[10,20,50,100]"
          :total="pagers.total"
          :page-size="fetchParams.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import SkuSelector from '@/components/function/skuSelector'
import { getCardList} from '@/api/cardticket'
import { getManufactorLogList,getListExpord} from '@/api/long'

export default {
  props: {
    isLoad: {
      type: Boolean,
      default: true
    },
  },
  provide() {
    return {
      refresh: this.getList
    }
  },
  data () {
    return {
      goods_id:'',
      upload_at:"",
      loading: false,
      loadingList:false,
      memberTagDialog:false,
      longList:[],
      dataList: [],
      pagers:{
        total: 0
      },
      title:"",
      coupon_title:"",
      category:[],
      pageSize:20,
      currentPage:1,
      goodsList:[],
      cardList:[],
      manufactorList:[],
      dialogLoading:false,
      exportloading:false,
      params: {},
      goodsDialog:{
          dialogLoading:true,
          goodsVisible:false,
      },
      form:{
        title: '',
        is_must:0,
        is_check:0,
        goods_info: [],
      },
      relItems: [],
      fetchParams:{}
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  components: {
      SkuSelector,
  },
  watch:{
    $route(to,from){
      this.getList()
    }
  },
  methods: {

    handleCancelLabelsDialog () {
      this.memberTagDialog = false
    },
    handleSkuRemove(){
      this.form.goods_info='';
    },

    exports(){
      getListExpord(this.params).then(res => {
          
            this.exportloading = false
            if (res.data.data.status) {
                this.$message({
                    type: 'success',
                    message: '已加入执行队列，请在设置-导出列表中下载'
                })
                return
            }else {
                this.$message({
                    type: 'error',
                    message: '无内容可导出 或 执行失败，请检查重试'
                })
                return
            }
        }).catch( error => {
            this.exportloading = false
        })
    },
    updateDateChange (val) {
        if (val && val.length > 0) {
            this.params.start = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
            this.params.end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
            this.params.start = ''
            this.params.end = ''
        }
        this.getList();
    },

    handleCurrentChange(val) {
      this.fetchParams.page = val
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.page = 1
      this.fetchParams.pageSize = pageSize
      this.getList()
    },

    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },

    dateChange (val) {
      if(val) {
        if (val.length > 0) {
          this.fetchParams.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.fetchParams.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.fetchParams.begin_time = ''
          this.fetchParams.end_time = ''
        }
      }else{
        this.fetchParams.begin_time = ''
        this.fetchParams.end_time = ''
      }
      this.params.page = 1
      this.getList()
    },

    getList () {
      this.loadingList = true
      getManufactorLogList(this.params).then(res => {
          this.dataList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loadingList = false
          })
    },
    search () {
      this.getList()
    },
    handleGoodsDialogCancel(){
        this.goodsDialog.goodsVisible = false
    },

  },
  mounted () {
    this.getList()
  }
}

</script>
<style scoped lang="scss">
.el-icon-edit {
  cursor: pointer;
}
.coupon-list {
  margin-top: 10px;
}
.coupon-item {
  position: relative;
  height: 130px;
  padding: 25px 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dadadd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  width: 19%;
  float: left;
  margin: .5%;
  &.coupon-add {
    padding-top: 20px;
    cursor: pointer;
    i {
      font-size: 40px;
    }
    :last-child { margin-top: 10px; }
  }
  .price {
    font-size: 24px;
  }
  .color-gray {
    color: #99A9BF;
  }
  .color-gray-deep {
    color: #8492A6;
  }
  .item-code {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.icon-triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 34px solid #20a0ff;
    border-left: 34px solid transparent;
    color: #fff;
  }
  label {
    position: absolute;
    top: -34px;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}
.item-bg {
  position: absolute;
  left: 0;
  bottom: -101%;
  width: 100%;
  height: 100%;
  background: rgba(241, 244, 246, .9);
  text-align: left;
  border-radius: 5px;
  padding-top: 8px;
  transition: all .4s ease;
  p {
    padding: 0 10px;
  }
  .item-operate {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    padding: 4px 0;
    text-align: center;
    cursor: pointer;
    a { color: #fff; }
  }
}
.coupon-item:hover {
  .item-bg {
    bottom: 0;
  }
}
.coupon-type-item {
  position: relative;
  padding: 30px 10px;
  border: 1px solid #ff5000;
  color: #ff5000;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  &:first-child {
    font-size: 18px;
  }
  .coupon-type-desc {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    padding: 10px 0;
    background: #ff5000;
    color: #fff;
    font-size: 18px;
    transition: all .4s ease;
    div:last-child {
      width: 70%;
      margin: 8px auto 0;
      font-size: 12px;
    }
  }
  &:hover {
    .coupon-type-desc {
      bottom: 0;
    }
  }
}

.coupon-type-item, .sendout-item {
  overflow: hidden;
  .icon-checked {
    display: none;
    width: 100px;
    height: 25px;
    transform: rotate(35deg);
    position: absolute;
    font-size: 14;
    top: 5px;
    right: -25px;
    font-size: 20px;
    color: #fff;
    background: #ff5000;
    i {
      transform: rotate(-35deg);
    }
  }
  &.checked {
    .icon-checked {
      display: block;
    }
  }

  &:hover .icon-checked {
    background: #fff;
    i {
      color: #ff5000;
    }
  }
}
.store-pop {
  padding: 20px 15px;
  .store-content {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// manufactor_log.vue?daa12bd8